import React from 'react'
import { Navigate, Outlet, useLocation, useMatch } from 'react-router-dom'

import { useAuth } from 'contexts/auth-context'
import { PATH_SIGN_IN } from 'pages/auth/SignInPage'
import { useTeamsQuery } from 'hooks/useApiQuery'
import { EXPIRED_TRIAL_PATH } from 'pages/ExpiredTrialPage'

export function RequireAuth() {
  const auth = useAuth()
  const location = useLocation()
  const { data: teams } = useTeamsQuery()
  const canRedirectToExpiredTrial = !useMatch(EXPIRED_TRIAL_PATH)

  if (!auth.isSignedIn) {
    return <Navigate to={PATH_SIGN_IN} state={{ from: location }} />
  }

  if (
    canRedirectToExpiredTrial &&
    teams != null &&
    teams.length === 1 &&
    teams[0].freeTrial?.isExpired === true
  ) {
    return <Navigate to={EXPIRED_TRIAL_PATH} state={{ teamUrlName: teams[0].urlName }} />
  }

  return <Outlet />
}
